import React from 'react';
import styled from 'styled-components';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.4);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
`;

const ModalContent = styled.div`
  background: #fff;
  color: #222;
  border-radius: 10px;
  max-width: 700px;
  width: 95vw;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 8px 32px rgba(0,0,0,0.2);
  padding: 36px 32px 32px 32px;
  position: relative;

  h1, h2, h3 {
    font-family: inherit;
    font-weight: 600;
    margin-top: 1.3em;
    margin-bottom: 0.7em;
    text-align: left;
  }
  h1 {
    font-size: 1.25rem;
  }
  h2 {
    font-size: 1.1rem;
  }
  h3 {
    font-size: 1rem;
  }
`;

const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: 16px;
  background: transparent;
  border: none;
  font-size: 1.7rem;
  color: #888;
  cursor: pointer;
  &:hover {
    color: #4a6cf7;
  }
`;

const ImpressumModal = ({ open, onClose }) => {
  if (!open) return null;
  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={e => e.stopPropagation()}>
        <CloseButton aria-label="Schließen" onClick={onClose}>&times;</CloseButton>
        <h1>Impressum</h1>
        <h2>eXplainable AI Solutions GmbH</h2>
        <h3>Unternehmensangaben</h3>
        <p>
          <strong>Geschäftsführer:</strong> Herr Thomas Leitgeb (alleinvertretungsberechtigt)<br/>
          <strong>Firmensitz:</strong> Johann Nepomuk Berger-Straße 7/RH47, 7210 Mattersburg, Österreich<br/>
          <strong>Telefon:</strong> +43 681 81734293<br/>
          <strong>E-Mail:</strong> <a href="mailto:office@companion.at">office@companion.at</a><br/>
          <strong>Web:</strong> <a href="https://companion.at" target="_blank" rel="noopener noreferrer">https://companion.at</a>
        </p>
        <h3>Firmenbuchdaten</h3>
        <p>
          <strong>Firmenbuchnummer:</strong> FN 644588 z<br/>
          <strong>Firmenbuchgericht:</strong> Landesgericht Eisenstadt<br/>
          <strong>UID-Nummer:</strong> ATU 81804601<br/>
          <strong>Rechtsform:</strong> Gesellschaft mit beschränkter Haftung (GmbH)<br/>
          <strong>Beginn der Rechtsform:</strong> 10.01.2025
        </p>
        <h3>Mitgliedschaften und rechtliche Rahmenbedingungen</h3>
        <p>
          Mitglied der Wirtschaftskammer Burgenland (Fachgruppe Unternehmensberatung, Buchhaltung und Informationstechnologie – Fachverband UBIT)<br/>
          Berufsrechtliche Vorschriften: Gewerbeordnung (abrufbar unter <a href="https://www.ris.bka.gv.at" target="_blank" rel="noopener noreferrer">www.ris.bka.gv.at</a>)<br/>
          Aufsichtsbehörde: Bezirkshauptmannschaft Mattersburg
        </p>
        <h3>Unternehmensgegenstand</h3>
        <p>
          Dienstleistungen in der automatischen Datenverarbeitung und Informationstechnologie.
        </p>
        <h3>Grundlegende Richtung des Mediums</h3>
        <p>
          Die Website und der Newsletter von eXplainable AI Solutions GmbH dienen der Information über Dienstleistungen des Unternehmens sowie über aktuelle Themen im Bereich Künstliche Intelligenz und erklärbare Systeme. Die Inhalte richten sich an Kunden, Partner und interessierte Personen.
        </p>
        <h3>Haftungsausschluss</h3>
        <p>
          Die Website und die bereitgestellten Informationen wurden mit größter Sorgfalt erstellt. Dennoch übernimmt die eXplainable AI Solutions GmbH keine Gewähr für die Aktualität, Richtigkeit, Vollständigkeit oder Fehlerfreiheit der bereitgestellten Inhalte.<br/>
          Für externe Links wird keine Haftung übernommen; verantwortlich sind ausschließlich die jeweiligen Betreiber der externen Websites. Die Auswahl und Überprüfung externer Inhalte erfolgt mit größter Sorgfalt und wird regelmäßig kontrolliert.
        </p>
        <h3>Geschlechtsneutrale Formulierung</h3>
        <p>
          Aus Gründen der besseren Lesbarkeit wird auf eine geschlechtsspezifische Differenzierung verzichtet. Alle personenbezogenen Bezeichnungen gelten gleichermaßen für alle Geschlechter.
        </p>
      </ModalContent>
    </ModalOverlay>
  );
};

export default ImpressumModal;
